import React, { useState, useEffect } from "react"; // Added useEffect
import { Button, Paper, Card, CardContent, Typography, Dialog, DialogTitle, DialogContent, Box, useTheme, useMediaQuery, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import alert from "./assets/MyImg/alt2.png";
import TableComponent from "./TableComponent";
import AttendanceApp from "./AttendanceApp";
import HeaderSection from "./HeaderSection";

const ProductWarning = () => {
  const [open, setOpen] = useState(false);
  const [PopupWarning, setPopupWarning] = useState([]); // Products with count <= previous
  const [warningProducts, setWarningProducts] = useState([]);
  const [loading, setLoading] = useState(true); // <-- Add loading state
  const navigate = useNavigate(); // Initialize useNavigate
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchWarningProducts = async () => {
      try {
        const res = await fetch("https://enzo-matr.onrender.com/api/products");
        const products = await res.json();
        const warningProducts = products.filter(product => product.count <= product.previous);
        setPopupWarning(warningProducts);
        setWarningProducts(
          warningProducts
            .sort((a, b) => a.count - b.count) // Sort by count in ascending order
            .slice(0, 3) // Display top 3 in the card
        );
      } catch (err) {
        console.error("Error fetching warning products:", err);
      } finally {
        setLoading(false); // <-- Set loading to false after fetch
      }
    };

    fetchWarningProducts();
  }, []);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleAddProduct = () => {
    navigate("/up-product"); // Navigate to the Update Product page
  };

  return (<>
    <HeaderSection />
    <Paper sx={{ background: "#eeecec", 
      height: isMobile ? "100vh" : isTablet ? "100vh" : "89vh",
       width: "100vw" }}>
      <Box
        sx={{
          bgcolor: "#20a4a3",
          p: 1,
          textAlign: "center",
          marginBottom: "0px",
          marginTop: "-10px",
          position: "relative"
        }}
      >
        <Typography variant={isMobile ? "h5" : "h4"} sx={{ fontWeight: "bold", color: "white", fontFamily: "caladea" }}>
          REPORT
        </Typography>
      </Box>
      <div>
        <Card
          variant="outlined"
          sx={{
            width: isMobile ? "98vw" : isTablet ? "93.5vw" : "760px",
            mt: 1,
            borderRadius: "10px",
            borderWidth: 1,
            height: isMobile ? "auto" : "130px",
            boxShadow: 1,
            ml: isMobile ? 0 : 2,
            mr: isMobile ? 0 : undefined,
            p: isMobile ? 1 : 0,
          }}
        >
          <CardContent>
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                ml: isMobile ? 0 : 1,
                alignItems: isMobile ? "flex-start" : "center",
                flexWrap: "wrap"
              }}
            >
              <Box>
                <Typography
                  variant={isMobile ? "h6" : "h1"}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    fontSize: isMobile ? "20px" : "30px",
                    fontFamily: "Bricolage Grotesque",
                    fontWeight: "bold"
                  }}
                >
                  <img src={alert} alt="err" height={isMobile ? 28 : 40} />Product Warning
                </Typography>
                <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#2baaab",
                      height: isMobile ? "36px" : "40px",
                      width: isMobile ? "90vw" : "300px",
                      fontFamily: "Bricolage Grotesque",
                      textTransform: 'none',
                      fontSize: isMobile ? "18px" : "25px"
                    }}
                    onClick={handleOpen}
                  >
                    View All
                  </Button>
                  {loading && (
                    <Box sx={{ display: "flex", alignItems: "center", ml: "150px",mt: isMobile ? 1 : -10
                     }}>
                      <CircularProgress size={28} color="primary" />
                      <Typography sx={{ ml: 1, color: "#333", fontWeight: "bold", fontSize: isMobile ? "13px" : "16px" }}>
                        loading......
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  minWidth: isMobile ? "auto" : 100,
                  ml: isMobile ? 0 : 40,
                  mt: isMobile ? 2 : "-100px"
                }}
              >
                {warningProducts.map((product, index) => (
                  <Box key={index} sx={{ display: "flex", alignItems: "center", mt: 0.5 }}>
                    <Typography sx={{ flex: 1, fontFamily: "Bricolage Grotesque", fontWeight: "bold", ml: isMobile ? "10px" : "30px" }}>{product.name}</Typography>
                    <Typography sx={{ flex: 1, fontFamily: "Bricolage Grotesque", fontWeight: "bold", textAlign: "center", ml: isMobile ? "20px" : "70px" }}>{product.count}</Typography>
                    <Button
                      variant="contained"
                      size="small"
                      onClick={handleAddProduct}
                      sx={{
                        flex: 1,
                        color: "white",
                        bgcolor: "#252525",
                        fontWeight: "bold",
                        fontFamily: "Bricolage Grotesque",
                        ml: isMobile ? "10px" : "40px"
                      }}
                    >
                      ADD
                    </Button>
                  </Box>
                ))}
              </Box>
            </Box>
          </CardContent>
        </Card>

        {/* Modal */}
        <Dialog
          open={open}
          onClose={handleClose}
          fullWidth
          sx={{
            "& .MuiDialog-paper": {
              width: "435px",
              height: "540px",
              borderRadius: "20px",
              bgcolor: "#FFFFFF"
            }
          }}
        >
          <DialogTitle
            align="center"
            variant="h4"
            fontFamily={"'Vastago Grotesk Bold', sans-serif"}
            fontWeight={"bold"}
            sx={{ mt: 2 }}
          >
            Product Warning
          </DialogTitle>
          <DialogContent
            sx={{
              p: 0,
              display: "flex",
              flexDirection: "column",
              height: "420px" // set height for scrollable area
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 1,
                p: 1,
                overflowY: "auto",
                height: "100%"
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  bgcolor: "black",
                  color: "white",
                  p: 1,
                  borderRadius: 2,
                  width: "350px",
                  minWidth: "350px",
                  mx: "auto"
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "bold",
                    ml: 5,
                    fontFamily: "'Vastago Grotesk Bold', sans-serif"
                  }}
                >
                  Product Name
                </Typography>
                <Typography
                  sx={{
                    fontWeight: "bold",
                    mr: 6,
                    fontFamily: "'Vastago Grotesk Bold', sans-serif"
                  }}
                >
                  count
                </Typography>
              </Box>
              <Box sx={{ overflowY: "auto", maxHeight: "340px", width: "100%", mx: "auto" }}>
                {PopupWarning.map((product, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      p: 1,
                      borderBottom: "1px solid #ddd",
                      width: "350px",
                      minWidth: "350px",
                      mx: "auto"
                    }}
                  >
                    <Typography sx={{ ml: 5, fontFamily: "'Vastago Grotesk Bold', sans-serif" }}>
                      {product.name}
                    </Typography>
                    <Typography sx={{ mr: 7, fontFamily: "'Vastago Grotesk Bold', sans-serif" }}>
                      {product.count}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <Box sx={{ display: "flex", mt: 2, justifyContent: "center", mb: 2 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleAddProduct}
                sx={{
                  width: 185,
                  height: "59px",
                  mr: 1,
                  ml: "1px",
                  bgcolor: "#007B88",
                  borderRadius: "10px",
                  fontFamily: "'Times New Roman', Arial, sans-serif",
                  fontSize: "20px"
                }}
              >
                ADD PRODUCT
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
                sx={{
                  width: 185,
                  bgcolor: "#525252",
                  borderRadius: "10px",
                  fontFamily: "'Times New Roman', Arial, sans-serif",
                  fontSize: "20px"
                }}
              >
                CANCEL
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      </div>
      <TableComponent setPopupWarning={setPopupWarning} setWarningProducts={setWarningProducts} />
      <AttendanceApp />
    </Paper>
  </>
  );
};

export default ProductWarning;